import type { RouteRecordRaw } from 'vue-router'

/**
 * 聚合业务逻辑（域 10，slug 保留 `business-orchestration`）后台**跨域聚合读**路由。
 *
 * ⚠️ **归属口径（`T-130-10` 同步）**：域 10 的现名是「**聚合业务逻辑**」（`design/domain-registry.js:50`，
 * RB-006 裁决 24）—— 它**不再是**「统一业务入口 / 转译所有平台业务指令」的域（裁决 1 判定该前提不必要）。
 * 本页对应的**唯一**后端端点是 `GET /api/v1/business/management/aggregate`（跨域聚合读），
 * 权限码 `business_orchestration.admin`；原「管理动作面板」与其后台（`POST /business/management/actions`）
 * 已按裁决 33／D-1a 整体删除（`T-130-08`）⇒ **本页是只读聚合视图**，无任何写入口。
 * （菜单显示名保留「业务编排」：i18n `routes.business-orchestration.title`，e2e 亦按该题名断言。）
 *
 * 菜单由 `layout/SideMenu.vue` 从 `router.options.routes` 自动派生 ⇒ 只需在此登记即可出现。
 * 页面级权限不在路由层拦截（项目既有约定：无 `meta.permission`，读端点由后端 403 兜底）
 * —— 视图内用 `business_orchestration.admin` 判定可用性，缺失时**不发起请求**并提示。
 */
const businessOrchestrationRoutes: RouteRecordRaw[] = [
  {
    path: 'business-orchestration',
    name: 'business-orchestration',
    meta: {
      titleKey: 'routes.business-orchestration.title',
      icon: 'Connection',
      helpKey: 'business_orchestration'
    },
    component: () => import('@/views/business-orchestration/BusinessOrchestration.vue')
  }
]

export default businessOrchestrationRoutes
